import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute({ children, fallback = null }) {
  const { auth, login } = useAuth();

  // Show loading state while checking authentication
  if (auth.loading) {
    return fallback || (
      <div className="flex items-center justify-center min-h-screen bg-[#1A1D23]">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#FCB634]"></div>
          <p className="mt-4 text-lg text-white font-medium">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to auth service
  if (!auth.isAuthenticated) {
    // Save intended destination for after login
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('authReturnUrl', window.location.href);
    }
    
    // Redirect to auth service
    login();
    
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#1A1D23]">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#FCB634]"></div>
          <p className="mt-4 text-lg text-white font-medium">Redirecting to login...</p>
        </div>
      </div>
    );
  }

  // User is authenticated, render the protected content
  return children;
}

export default ProtectedRoute; 